import { useMediaQuery } from '@mantine/hooks';
import resolveConfig from 'tailwindcss/resolveConfig.js';

import tw_config from '../../tailwind.config.ts';

interface BreakpointHook {
    is_sm: boolean;
    is_md: boolean;
    is_lg: boolean;
    is_xl: boolean;
    is_2xl: boolean;
    is_less_than_xl: boolean;
}

const useBreakpoints = (): BreakpointHook => {
    const tailwind_config = resolveConfig(tw_config);
    const screens = tailwind_config.theme.screens;

    const is_sm = useMediaQuery(`(min-width: ${screens.sm})`);
    const is_md = useMediaQuery(`(min-width: ${screens.md})`);
    const is_lg = useMediaQuery(`(min-width: ${screens.lg})`);
    const is_xl = useMediaQuery(`(min-width: ${screens.xl})`);
    const is_2xl = useMediaQuery(`(min-width: ${screens['2xl']})`);
    const is_less_than_xl = !is_xl;

    return {
        is_sm,
        is_md,
        is_lg,
        is_xl,
        is_2xl,
        is_less_than_xl,
    };
};

export default useBreakpoints;
